import { createFeature } from '@ngrx/store';

import { pecReducer } from './pec.reducer';

export const pecFeature = createFeature({
  name: 'pec',
  reducer: pecReducer,
});
